// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"table-module--wrapper--16xJK"};